var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCleaner = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User/Regular/Cleaner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "user-shield",
    d: "M9.759 10.5C7.428 10.5 5.509 8.581 5.509 6.25C5.509 3.919 7.428 2 9.759 2C12.09 2 14.009 3.919 14.009 6.25C14.006 8.58 12.089 10.497 9.759 10.5ZM9.759 3.5C8.25 3.5 7.009 4.741 7.009 6.25C7.009 7.759 8.25 9 9.759 9C11.268 9 12.509 7.759 12.509 6.25C12.508 4.742 11.267 3.501 9.759 3.5ZM13 21.5H5.75C3.332 21.5 2 20.175 2 17.77C2 15.108 3.506 12 7.75 12H13.973C14.348 11.996 14.722 12.023 15.092 12.08C15.466 12.126 15.75 12.448 15.75 12.824C15.75 13.236 15.411 13.574 15 13.574C14.951 13.574 14.902 13.57 14.854 13.56C14.563 13.517 14.268 13.497 13.973 13.5H7.75C7.649 13.492 7.547 13.488 7.446 13.488C5.274 13.488 3.487 15.275 3.487 17.447C3.487 17.555 3.491 17.663 3.5 17.77C3.5 19.333 4.173 20 5.75 20H13C13.411 20 13.75 20.339 13.75 20.75C13.75 21.161 13.411 21.5 13 21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2502 21.7499C16.6625 21.7482 15.1217 20.4037 15.1196 18.6229C15.1196 15.9778 18.1862 13.75 18.2502 13.75C18.3142 13.75 21.3807 15.9791 21.3807 18.6229C21.3786 20.4037 19.8378 21.752 18.2502 21.7499Z",
    stroke: "#3378FF",
    strokeWidth: 1.49906,
    strokeMiterlimit: 2,
    strokeLinejoin: "round",
    fill: "#FFFFFF00"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCleaner, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cleaner.5c7fb942.svg";
export { ForwardRef as ReactComponent };